import React, { FC, useEffect, useState } from "react";
import { DEF_PG_SIZE_SUB } from '../../constants/maximum-page-size';
import { TableContextProvider } from "../../contexts/table/TableContextProvider";
import { ListData } from "../../models/ListData";
import { ListQuery } from "../../models/ListQuery";
import { Lookup } from "../../models/Lookup";
import { SearchTerm } from "../../models/search/SearchTerm";
import { TableColumn } from "../../models/table/TableColumn";
import TableTab from "../tabs/table-tab";

interface Props {
    searchColumn: SearchTerm[];
    column: TableColumn[];
    id: string;
    dataMethod: (query?: ListQuery) => Promise<ListData>;
    title: string;
    lookup?: Lookup[];
}

const AssignedTab: FC<Props> = ({ searchColumn, column, id, dataMethod, lookup, children, title }) => {
    useEffect(() => {
        dataRefresh((query) => dataMethod(query));
    }, [id])

    const [dataRefresh, setDataRefresh] = useState(() => (dataMethod?: (query?: ListQuery) => Promise<ListData>) => { return });

    const manualDataRefresh = (refreshData: (dataMethod?: (query?: ListQuery) => Promise<ListData>) => void) => {
        setDataRefresh(() => refreshData);
    };

    return <TableContextProvider
        dataMethod={dataMethod}
        manualDataRefresh={manualDataRefresh}
        tableDescriptor={column}
        searchDescriptor={searchColumn}
        useTable
        usePagination
        useSort
        useSearch
        useFilter
        maxPageSize={DEF_PG_SIZE_SUB}
        lookup={lookup}
        canExportReport={false}>
        <TableTab
            cyName="manageItems_tbl"
            title={title}
            selectRows={false}>
            {children}
        </TableTab>
    </TableContextProvider>
};

export default AssignedTab;
